<div style="background-color: #F5F7F8; height: 100vh; overflow-y: scroll; padding: 10px; padding-top: 20px;">
  <img style="width: 22px; height: 22px; position: relative; top: 30px; left: 15px;" (click)="this.back()" src="/assets/images/shared/back.svg">
  <h2 style="text-align: center; margin-top: 3px;">Детайли за заявка</h2>

  <div style="overflow-y: scroll; margin-bottom: 5px;">
    <div *ngIf="this.return" style="margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
      <div *ngFor="let productPerOrg of this.order?.data?.lines">
        <div *ngIf="this.isCartReturned(productPerOrg.uuid)" style="height: 155px; width: 100%;">
          <div style="height: 140px; margin: 0px; margin-top: 10px;" class="row">
            <label style="width: 100px; height: 110px; padding: 3px; border: 1px solid #EDF5FC; border-radius: 10px; margin-top: 10px; vertical-align: unset;" [for]="productPerOrg.uuid">
              <img style="width: 90px; height: 100px; vertical-align: unset;" [src]="productPerOrg.imageSource" alt="">
            </label>

            <div class="col-7" style="display: inline-block; margin-top: 10px; flex: 0 0 67%; max-width: 67%;">
              <p
                (click)="this.goToProduct(productPerOrg)"
                style="font-size: 13px; font-weight: bold; margin-bottom: 5px; display: -webkit-box; -webkit-line-clamp: 2; line-clamp: 2; -webkit-box-orient: vertical; height: 40px; overflow: hidden; text-overflow: ellipsis; text-align: left; margin-top: 5px;"
              >
                {{ productPerOrg.sku.product.name }}
              </p>

              <p *ngIf="productPerOrg.sku?.options?.length" style="font-size: 10px; color: #ADAFBB;">
                <span *ngFor="let option of productPerOrg.sku?.options || []; index as i">
                  {{ option.option?.display_name + ': ' + this.returnOptionValue(option) + ((i != productPerOrg.sku.options.length - 1) ? ' | ' : '') }}
                </span>
              </p>

              <p *ngIf="!productPerOrg.sku.options.length" style="font-size: 10px; color: #ADAFBB;">&nbsp;</p>

              <div *ngIf="this.request" style="min-width: 200px;">
                <div class="return-detail-item-row">
                  <div class="return-detail-item-info">
                    <app-price
                      class="return-detail-line-total-price"
                      [amount]="getLineTotalBase(productPerOrg, this.return, productPerOrg.uuid)"
                      layout="inline"
                    ></app-price>

                    <div class="return-detail-item-subprice">
                      <span class="return-detail-line-mult">
                        {{ pricingInfoText(this.return, productPerOrg.uuid) }}
                      </span>
                      <app-price
                        class="return-detail-line-unit-price"
                        [amount]="getUnitPriceBase(productPerOrg)"
                        layout="inline"
                      ></app-price>
                    </div>
                  </div>

                  <div class="return-detail-item-qty">
                    <span><span style="color: #ADAFBB;">Брой: </span>{{ this.returnReturnQuantityForProduct(return, productPerOrg.uuid) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 18px; margin-bottom: 10px;">
        </div>
      </div>
    </div>

    <div class="row" style="margin: auto; background-color: #E4F2FE; margin-top: 10px; border-radius: 10px; padding: 10px;">
      <div class="form-check col-1" style="display: grid; vertical-align: top; place-items: center;">
        <img style="width: 22px; height: 22px; margin-left: -10px;" src="/assets/images/vouchers/information.svg">
      </div>
      <p class="col-10" style="top: 7px">
        Моля, след подаване на заявката за връщане, изпратете продуктите до посочения адрес.
      </p>
    </div>

    <div *ngIf="this.organisation" style="margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
      <h4 style="font-weight: bold;">Адрес за връщане на продукти</h4>

      <div class="row" style="margin-top: 12px;">
        <div class="col-6" style="text-align: left;">Фирма:</div>
        <div class="col-6" style="text-align: right;">{{ this.organisation!.data.native_name + ' ' + this.organisation!.data.legal_form.label }}</div>
      </div>

      <div class="row" style="margin-top: 12px;">
        <div class="col-6" style="text-align: left;">Област:</div>
        <div class="col-6" style="text-align: right;">{{ this.organisation?.data?.return_address?.province || '-' }}</div>
      </div>

      <div class="row" style="margin-top: 12px;">
        <div class="col-6" style="text-align: left;">Населено място:</div>
        <div class="col-6" style="text-align: right;">{{ this.organisation?.data?.return_address?.city }}</div>
      </div>

      <div class="row" style="margin-top: 12px;">
        <div class="col-6" style="text-align: left;">Адрес:</div>
        <div class="col-6" style="text-align: right;">{{ this.streetInfo }}</div>
      </div>

      <div class="row" style="margin-top: 12px;">
        <div class="col-6" style="text-align: left;">Телефон за контакт:</div>
        <div class="col-6" style="text-align: right;">{{ this.organisation?.data?.return_address?.mobile_phone_1_e164 }}</div>
      </div>

      <div class="row" style="margin-top: 12px;">
        <div class="col-6" style="text-align: left;">Пояснения:</div>
        <div class="col-6" style="text-align: right;">{{ this.organisation?.data?.return_address?.description || '-' }}</div>
      </div>
    </div>

    <div *ngIf="this.request" style="margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
      <h4 style="font-weight: bold;">Детайли за заявка</h4>

      <div class="row" style="margin-top: 12px;">
        <div class="col-6" style="text-align: left;">Статус:</div>
        <div class="col-6" style="text-align: right; color: #0A69EB;" [class]="this.getStatusClass(this.request!.state)">{{ this.returnState(this.request!.state) }}</div>
      </div>

      <div class="row" style="margin-top: 12px;">
        <div class="col-5" style="text-align: left;">Дата на заявка:</div>
        <div class="col-7" style="text-align: right;">{{ this.date(this.request!.created_at) + ', ' + this.time(this.request!.created_at) }}</div>
      </div>

      <div class="row" style="margin-top: 12px;">
        <div class="col-6" style="text-align: left;">ID на заявка:</div>
        <div class="col-6" style="text-align: right;">{{ this.request!.uuid }}</div>
      </div>

      <div class="row refunded-amount" style="margin-top: 12px;">
        <div class="col-6" style="text-align: left;">Изплатена сума:</div>
        <div class="col-6" style="text-align: right;">
          <app-price
            *ngIf="getRefundedAmountBase() > 0; else emptyRefundAmount"
            [amount]="getRefundedAmountBase()"
            layout="inline"
          ></app-price>

          <ng-template #emptyRefundAmount>-</ng-template>
        </div>
      </div>

      <div class="row" style="margin-top: 12px;">
        <div class="col-6" style="text-align: left;">Причина за връщане:</div>
        <div class="col-6" style="text-align: right;">{{ this.return!.data.return_reason }}</div>
      </div>
    </div>

    <div *ngIf="this.request" style="margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
      <h4 style="font-weight: bold;">Банкови детайли</h4>

      <div class="row" style="margin-top: 12px;">
        <div class="col-5" style="text-align: left;">IBAN:</div>
        <div class="col-7" style="text-align: right;">{{ this.request!.iban }}</div>
      </div>

      <div class="row" style="margin-top: 12px;">
        <div class="col-6" style="text-align: left;">Банка:</div>
        <div class="col-6" style="text-align: right;">{{ this.request!.bank_name }}</div>
      </div>

      <div class="row" style="margin-top: 12px;">
        <div class="col-6" style="text-align: left;">Титуляр на сметка:</div>
        <div class="col-6" style="text-align: right;">{{ this.request!.account_owner }}</div>
      </div>
    </div>

    <div *ngIf="this.request?.fullOrder" style="margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
      <h4 style="font-weight: bold;">Детайли на поръчка</h4>

      <div class="row" style="margin-top: 12px;">
        <div class="col-5" style="text-align: left;">Дата на поръчка:</div>
        <div class="col-7" style="text-align: right;">{{ this.date(this.request!.fullOrder!.data.created_at) + ', ' + this.time(this.request!.fullOrder!.data.created_at) }}</div>
      </div>

      <div class="row" style="margin-top: 12px;">
        <div class="col-6" style="text-align: left;">ID на поръчка:</div>
        <div class="col-6" style="text-align: right;">{{ this.request!.fullOrder!.data.uuid }}</div>
      </div>

      <div class="row" style="margin-top: 12px;">
        <div class="col-4" style="text-align: left;">Метод на плащане:</div>
        <div *ngIf="this.isCOD(this.request!.fullOrder!)" class="col-8" style="text-align: right;">Наложен платеж</div>
        <div *ngIf="!this.isCOD(this.request!.fullOrder!) && this.request!.paymentIntent" class="col-8" style="text-align: right;">
          <img *ngIf="this.cardImg" style="width: 44px; height: 44px; margin: 5px; margin-top: 0px;" [src]="this.cardImg" alt="">
          <p style="padding-left: 0px; display: inline-block; margin: 5px; font-size: 14px !important;">{{ this.getCardDetail }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
